// Base URL ---------------------------------------------------------------

// Live
const BASE_URL = "https://api.indxx.com/";

// Indxx calculation
// const BASE_URL = "https://api.indxxwebsite.indexcalculation.com/";

// QA
// export const BASE_URL = "http://15.206.224.193:3001/";

// QA Prod
// export const BASE_URL = "http://15.206.224.193:4001/";

// UAT
// const BASE_URL = "http://15.206.224.193:4000/";

// Prod
// const BASE_URL = "http://15.206.224.193:8083/";

// Prodtest
// const BASE_URL = "http://65.1.9.150:8081/";

// ------------------------------------------------------------------------

// Tabs
// export const GET_TABS = BASE_URL + "ui/tabs/";
export const GET_TABS = BASE_URL + "ui/menu/";

// Config
export const GET_CONFIG = BASE_URL + "ui/config/";

// Carousel
export const GET_CAROUSEL_TABS = BASE_URL + "ui/carousel/";

// Clients
export const GET_LICENCED_CLIENTS = BASE_URL + "ui/licenced_client/";

// buiness offering
export const GET_BUSINESS_OFFERINGS = BASE_URL + "ui/business_offerings/";
export const GET_INDXX_INDICES = BASE_URL + "ui/offerings/Indxx Indices/";
export const GET_CUSTOM_INDICES = BASE_URL + "ui/offerings/Custom Indices/";
export const GET_CLIENT_INDICES = BASE_URL + "ui/offerings/Client Indices/";
export const GET_EQUITY_BASKET_CALCULATION =
  BASE_URL + "ui/offerings/Equity Basket Calculation/";
export const GET_INDXX_SERVICES = BASE_URL + "ui/offerings/Index Services/";
export const GET_INDXX_DATA_AND_TECHNOLOGY =
  BASE_URL + "ui/offerings/Indxx Data & Technology/";

// Types Of Indices Offered
export const GET_INDXX_TYPES = BASE_URL + "ui/indextypes/";

// awards
export const GET_AWARDS = BASE_URL + "ui/awards/";
export const GET_REWARDS = BASE_URL + "ui/rewards/";

// News and Research
export const GET_NEWS_AND_RESEARCH_BY_LIMIT = BASE_URL + "ui/newsandresearch/";
export const GET_INDXX_INSIGHTS_BY_YEAR = BASE_URL + "ui/indxxinsightyear/";
export const GET_IN_THE_NEWS_BY_YEAR = BASE_URL + "ui/newsyear/";
export const GET_PRESS_RELEASES_BY_YEAR = BASE_URL + "ui/pressreleaseyear/";
export const GET_NEWS_AND_RESEARCH = BASE_URL + "ui/new_insights_press/";

// Announcements
export const GET_ANNOUNCEMENTS_BY_LIMIT = BASE_URL + "ui/announcements/";
export const GET_NOTIFICATIONS_BY_YEAR = BASE_URL + "ui/announcementyear/";
export const POST_ANNOUNCEMENT_TRACKER = BASE_URL + "ui/announcemateTracker/";
export const GET_DOCUMENTS_BY_YEAR = BASE_URL + "ui/documentstyear/";

// Contact Us
export const GET_CONTACT_US = BASE_URL + "contactus/";
export const POST_CONTACT_US = BASE_URL + "contactus/";

// about us
export const GET_ABOUT_US = BASE_URL + "ui/aboutus/";
export const GET_PEOPLE = BASE_URL + "ui/people/";

// indices
export const GET_INDICES = BASE_URL + "ui/indices/";

// Contacus page
export const GET_OFFICE_LOCATION = BASE_URL + "ui/officelocation/";

// career
export const GET_CAREER = BASE_URL + "ui/career/";
export const GET_TESTIMONIALS = BASE_URL + "ui/testimonials/";
export const GET_CURRENT_OPENINGS = BASE_URL + "ui/current_openings/";
export const GET_CURRENT_OPENINGS_REGION =
  BASE_URL + "ui/current_openings_region/";
export const GET_LIFE_AT_INDXX = BASE_URL + "ui/lifeatindxx/";

//newsandresearchinsider
export const GET_NEWS_AND_RESEARCH_INSIDER = BASE_URL + "ui/indxxinsights/";
//cadmin
export const GET_CADMIN = BASE_URL + "ui/cadmindetails/";

//itics
export const GET_ITICS = BASE_URL + "ui/iticsdetails/";

//careerjobdescription
export const GET_CAREER_JOB_DESCRIPTION = BASE_URL + "ui/current_openings/";

//press release
export const GET_PRESS_RELEASE = BASE_URL + "ui/pressrelease/";

//indivisual Index Name
export const GET_INDIVISUAL_INDEX = BASE_URL + "ui/index/";
export const POST_INDEX_VALUE_DOWNLOAD = BASE_URL + "ui/indexvaluedownload/";

//COOKIE
export const POST_COOKIESAVE = BASE_URL + "ui/cookiesave/";
export const POST_COOKIECHECK = BASE_URL + "ui/cookiecheck/";

//CAREER JOB DESCRIPTION
export const POST_APPLYJOB = BASE_URL + "ui/apply/";

//Search
export const POST_SEARCH = BASE_URL + "ui/textsearch/";
export const GET_SEARCH_SUGGESTION = BASE_URL + "ui/indexsuggestion/";

// Authentication
export const POST_SIGN_UP = BASE_URL + "ui/signup/";
export const POST_SIGN_UP_OTP = BASE_URL + "ui/signupconfirmation/";
export const POST_RESEND_OTP = BASE_URL + "ui/resendotp/";
export const POST_VERIFY_USER = BASE_URL + "ui/verify-user/";
